import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const ReviewView = lazy(async () => {
  const m = await import("@/features/workforce/components/review-view");
  return { default: m.ReviewView };
});

export const reviewRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/review",
  component: () => (
    <Suspense fallback={null}>
      <ReviewView />
    </Suspense>
  ),
});
